<template>
    <index-purchases :url="url" />
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import IndexPurchases from './IndexPurchases.vue';

export default {
    name: "",
    components: {
        IndexPurchases
    },
    data(){
        return {
            url: '/purchases/courses',
        }
    },
    computed: {
        ...GlobalComputed,
        
    },
    methods: {
        ...GlobalMethods,
    },
    watch: {
        
    },
    mounted(){
        
    }
};
</script>
<style lang="scss" scoped>

</style>
